/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, Image, Font, StyleSheet } from "@react-pdf/renderer";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: process.env.PUBLIC_URL + "/fonts/roboto-v20-latin-regular.ttf" });
Font.register({ family: "RobotoMedium", src: process.env.PUBLIC_URL + "/fonts/Roboto-Medium.ttf" });

const UtilsInstance = new Utils();

var currentSummaryIndex = 0;
// Summary indexes
var duplicatedIpPageIndex = 0;
var avgPingExceededPageIndex = 0;
var dhcpConfigDetectedPageIndex = 0;
var packetLossLimitExceededPageIndex = 0;
var inactivePortPageIndex = 0;
var portNotInAutonegotiationPageIndex = 0;
var portNotInFullDuplexPageIndex = 0;
var interfaceSpeedLessThan100PageIndex = 0;
var portWithHardwareFaultPageIndex = 0;
var addressConflictDetectedPageIndex = 0;
var mediaCountersPageIndex = 0;
var interfaceCountersPageIndex = 0;
var faultPageIndex = 0;
var lostIpPageIndex = 0;
var disclaimerPageIndex = 0;

export class TsExpertReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),

      // Summary
      firstDuplicatedIpPage: -1,
      firstAvgPingExceededPage: -1,
      firstDhcpConfigDetectedPage: -1,
      firstPacketLossLimitExceededPage: -1,
      firstInactivePortPage: -1,
      firstPortNotInAutonegotiationPage: -1,
      firstPortNotInFullDuplexPage: -1,
      firstInterfaceSpeedLessThan100Page: -1,
      firstPortWithHardwareFaultPage: -1,
      firstAddressConflictDetectedPage: -1,
      firstMediaCountersPage: -1,
      firstInterfaceCountersPage: -1,
      firstfaultPage: -1,
      firstLostIpPage: -1,
      // Summary numbering control
      isFirstDuplicatedIpPage: true,
      isFirstAvgPingExceededPage: true,
      isFirstDhcpConfigDetectedPage: true,
      isFirstPacketLossLimitExceeded: true,
      isFirstInactivePort: true,
      isFirstPortNotInAutonegotiation: true,
      isFirstPortNotInFullDuplex: true,
      isFirstInterfaceSpeedLessThan100: true,
      isFirstPortWithHardwareFault: true,
      isFirstAddressConflictDetected: true,
      isFirstMediaCounters: true,
      isFirstInterfaceCounters: true,
      isFirstfaultPage: true,
      isFirstLostIpPage: true,
      // The report itself
      doc: ""
    };

  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  formatTime = (problem) => {
    if (problem.ntp !== null && problem.ntp === true) {
      let parsedMillis = Date.parse(problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString(Strings.DATE_LOCALE);

    }
    else if (problem.time !== undefined && problem.time !== null) {
      const eventTimeInMillis = problem.time * 1000;
      const uptimeInMillis = this.props.startTime * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - uptimeInMillis + eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString(Strings.DATE_LOCALE));
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={process.env.PUBLIC_URL + "/logo_report.png"} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.TS_EXPERT_REPORT_EXPORT_NAME}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, ${Strings.REPORT_PAGE} ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "duplicatedIp" && this.state.isFirstDuplicatedIpPage) {
      this.setState({
        firstDuplicatedIpPage: pageNumber + 1,
        isFirstDuplicatedIpPage: false
      });
    }
    else if (reportPart === "avgPingExceeded" && this.state.isFirstAvgPingExceededPage) {
      this.setState({
        firstAvgPingExceededPage: pageNumber + 1,
        isFirstAvgPingExceededPage: false
      });
    }
    else if (reportPart === "dhcpConfigDetected" && this.state.isFirstDhcpConfigDetectedPage) {
      this.setState({
        firstDhcpConfigDetectedPage: pageNumber + 1,
        isFirstDhcpConfigDetectedPage: false
      });
    }
    else if (reportPart === "packetLossLimitExceeded" && this.state.isFirstPacketLossLimitExceeded) {
      this.setState({
        firstPacketLossLimitExceededPage: pageNumber + 1,
        isFirstPacketLossLimitExceeded: false
      });
    }
    else if (reportPart === "inactivePort" && this.state.isFirstInactivePort) {
      this.setState({
        firstInactivePortPage: pageNumber + 1,
        isFirstInactivePort: false
      });
    }
    else if (reportPart === "portNotInAutonegotiation" && this.state.isFirstPortNotInAutonegotiation) {
      this.setState({
        firstPortNotInAutonegotiationPage: pageNumber + 1,
        isFirstPortNotInAutonegotiation: false
      });
    }
    else if (reportPart === "portNotInFullDuplex" && this.state.isFirstPortNotInFullDuplex) {
      this.setState({
        firstPortNotInFullDuplexPage: pageNumber + 1,
        isFirstPortNotInFullDuplex: false
      });
    }
    else if (reportPart === "interfaceSpeedLessThan100" && this.state.isFirstInterfaceSpeedLessThan100) {
      this.setState({
        firstInterfaceSpeedLessThan100Page: pageNumber + 1,
        isFirstInterfaceSpeedLessThan100: false
      });
    }
    else if (reportPart === "portWithHardwareFault" && this.state.isFirstPortWithHardwareFault) {
      this.setState({
        firstPortWithHardwareFaultPage: pageNumber + 1,
        isFirstPortWithHardwareFault: false
      });
    }
    else if (reportPart === "addressConflictDetected" && this.state.isFirstAddressConflictDetected) {
      this.setState({
        firstAddressConflictDetectedPage: pageNumber + 1,
        isFirstAddressConflictDetected: false
      });
    }
    else if (reportPart === "mediaCounters" && this.state.isFirstMediaCounters) {
      this.setState({
        firstMediaCountersPage: pageNumber + 1,
        isFirstMediaCounters: false
      });
    }
    else if (reportPart === "interfaceCounters" && this.state.isFirstInterfaceCounters) {
      this.setState({
        firstInterfaceCountersPage: pageNumber + 1,
        isFirstInterfaceCounters: false
      });
    }
    else if (reportPart === "fault" && this.state.isFirstfaultPage) {
      this.setState({
        firstfaultPage: pageNumber + 1,
        isFirstfaultPage: false
      });
    }
    else if (reportPart === "lostIp" && this.state.isFirstLostIpPage) {
      this.setState({
        firstLostIpPage: pageNumber + 1,
        isFirstLostIpPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.TS_EXPERT_REPORT_EXPORT_NAME}>
      {this.createIntroPage()}
      {this.createSummaryPage()}
      {this.createDuplicateIPPages()}
      {this.createAvgPingExceededPages()}
      {this.createDhcpConfigDetectedPages()}
      {this.createPacketLossLimitExceededPages()}
      {this.createInactivePortPages()}
      {this.createPortNotInAutonegotiationPages()}
      {this.createPortNotInFullDuplexPages()}
      {this.createInterfaceSpeedLessThan100Pages()}
      {this.createPortWithHardwareFaultPages()}
      {this.createAddressConflictDetectedPages()}
      {this.createMediaCountersPages()}
      {this.createInterfaceCountersPages()}
      {this.createFaultsPages()}
      {this.createLostIpPages()}
      {this.createDisclaimerPage()}
    </Document>;

    return doc;
  }

  createIntroPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "28vh" }} />

        <View style={reusableStyles.mainTitleUpperLine} />

        <Text style={reusableStyles.mainTitle}>
          {Strings.TS_EXPERT_REPORT_TITLE}
        </Text>

        <Text style={reusableStyles.mainTitle2}>
          {Strings.TS_EXPERT_REPORT_ACTION_LIST}
        </Text>

        <View style={reusableStyles.mainTitleBottomLine} />

        {this.getPageFooter()}
      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        {this.getSummaryItem(Constants.DUPLICATE_IP_ERROR_TYPE)}
        {this.getSummaryItem(Constants.PING_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DHCP_ERROR_TYPE)}
        {this.getSummaryItem(Constants.PACKET_LOSS_ERROR_TYPE)}
        {this.getSummaryItem(Constants.INACTIVE_PORT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE)}
        {this.getSummaryItem(Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE)}
        {this.getSummaryItem(Constants.INTERFACE_SPEED_ERROR_TYPE)}
        {this.getSummaryItem(Constants.HARDWARE_FAULT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.ADDR_CONFLICT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.MEDIA_COUNTERS_TYPE)}
        {this.getSummaryItem(Constants.INTERFACE_COUNTERS_TYPE)}
        {this.getSummaryItem(Constants.FAULT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.LOST_IP_ERROR_TYPE)}
        {this.getSummaryItem("disclaimer")}

        {this.getPageFooter()}

      </Page>
    );
  }

  getSummaryItem = (type) => {

    if (type === Constants.DUPLICATE_IP_ERROR_TYPE && this.props.duplicatedIp.length > 0) {
      currentSummaryIndex++;
      duplicatedIpPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {duplicatedIpPageIndex}. {Strings.DUPLICATE_IP_STRING} {Strings.DUPLICATE_IP_DOTS} {this.state.firstDuplicatedIpPage}
        </Text>
      );
    }
    else if (type === Constants.PING_ERROR_TYPE && this.props.avgPingExceededLimit.length > 0) {
      currentSummaryIndex++;
      avgPingExceededPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {avgPingExceededPageIndex}. {Strings.AVG_PING_EXCEEDED} {Strings.AVG_PING_EXCEEDED_DOTS} {this.state.firstAvgPingExceededPage}
        </Text>
      );
    }
    else if (type === Constants.DHCP_ERROR_TYPE && this.props.dhcpConfigDetected.length > 0) {
      currentSummaryIndex++;
      dhcpConfigDetectedPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {dhcpConfigDetectedPageIndex}. {Strings.DHCP_CONFIG_METHOD} {Strings.DHCP_CONFIG_METHOD_DOTS} {this.state.firstDhcpConfigDetectedPage}
        </Text>
      );
    }
    else if (type === Constants.PACKET_LOSS_ERROR_TYPE && this.props.packetLossLimitExceeded.length > 0) {
      currentSummaryIndex++;
      packetLossLimitExceededPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {packetLossLimitExceededPageIndex}. {Strings.PACKET_LOSS_GREATER_ONE_PERCENT} {Strings.PACKET_LOSS_GREATER_ONE_PERCENT_DOTS} {this.state.firstPacketLossLimitExceededPage}
        </Text>
      );
    }
    else if (type === Constants.INACTIVE_PORT_ERROR_TYPE && this.props.inactivePort.length > 0) {
      currentSummaryIndex++;
      inactivePortPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {inactivePortPageIndex}. {Strings.INACTIVE_PORT} {Strings.INACTIVE_PORT_DOTS} {this.state.firstInactivePortPage}
        </Text>
      );
    }
    else if (type === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE && this.props.portNotInAutonegotiation.length > 0) {
      currentSummaryIndex++;
      portNotInAutonegotiationPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {portNotInAutonegotiationPageIndex}. {Strings.AUTONEGOTIATION_FAILED} {Strings.AUTONEGOTIATION_FAILED_DOTS} {this.state.firstPortNotInAutonegotiationPage}
        </Text>
      );
    }
    else if (type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE && this.props.portNotInFullDuplex.length > 0) {
      currentSummaryIndex++;
      portNotInFullDuplexPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {portNotInFullDuplexPageIndex}. {Strings.PORT_NOT_IN_FULL_DUPLEX} {Strings.PORT_NOT_IN_FULL_DUPLEX_DOTS} {this.state.firstPortNotInFullDuplexPage}
        </Text>
      );
    }
    else if (type === Constants.INTERFACE_SPEED_ERROR_TYPE && this.props.interfaceSpeedLessThan100.length > 0) {
      currentSummaryIndex++;
      interfaceSpeedLessThan100PageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {interfaceSpeedLessThan100PageIndex}. {Strings.INTERFACE_SPEED_LESSER_THAN_100} {Strings.INTERFACE_SPEED_LESSER_THAN_100_DOTS} {this.state.firstInterfaceSpeedLessThan100Page}
        </Text>
      );
    }
    else if (type === Constants.HARDWARE_FAULT_ERROR_TYPE && this.props.portWithHardwareFault.length > 0) {
      currentSummaryIndex++;
      portWithHardwareFaultPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {portWithHardwareFaultPageIndex}. {Strings.PORT_WITH_LOCAL_HARDWARE_FAULT} {Strings.PORT_WITH_LOCAL_HARDWARE_FAULT_DOTS} {this.state.firstPortWithHardwareFaultPage}
        </Text>
      );
    }
    else if (type === Constants.ADDR_CONFLICT_ERROR_TYPE && this.props.addressConflictDetected.length > 0) {
      currentSummaryIndex++;
      addressConflictDetectedPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {addressConflictDetectedPageIndex}. {Strings.ADDR_CONFLICT_DETECTED} {Strings.ADDR_CONFLICT_DETECTED_DOTS} {this.state.firstAddressConflictDetectedPage}
        </Text>
      );
    }
    else if (type === Constants.MEDIA_COUNTERS_TYPE && this.props.mediaCounters.length > 0) {
      currentSummaryIndex++;
      mediaCountersPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {mediaCountersPageIndex}. {Strings.MEDIA_COUNTERS} {Strings.MEDIA_COUNTERS_DOTS} {this.state.firstMediaCountersPage}
        </Text>
      );
    }
    else if (type === Constants.INTERFACE_COUNTERS_TYPE && this.props.interfaceCounters.length > 0) {
      currentSummaryIndex++;
      interfaceCountersPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {interfaceCountersPageIndex}. {Strings.INTERFACE_COUNTERS} {Strings.INTERFACE_COUNTERS_DOTS} {this.state.firstInterfaceCountersPage}
        </Text>
      );
    }
    else if (type === Constants.FAULT_ERROR_TYPE && this.props.faults.length > 0) {
      currentSummaryIndex++;
      faultPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {faultPageIndex}. {Strings.DEVICE_WITH_FAULT} {Strings.DEVICE_WITH_FAULT_DOTS} {this.state.firstfaultPage}
        </Text>
      );
    }
    else if (type === Constants.LOST_IP_ERROR_TYPE && this.props.lostIp.length > 0) {
      currentSummaryIndex++;
      lostIpPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {lostIpPageIndex}. {Strings.DEVICE_WITH_LOST_IP} {Strings.DEVICE_WITH_LOST_IP_DOTS} {this.state.firstLostIpPage}
        </Text>
      );
    }
    else if (type === "disclaimer") {
      currentSummaryIndex++;
      disclaimerPageIndex = currentSummaryIndex;
      if (disclaimerPageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.TS_EXPERT_DISCLAIMER_DOTS} ${totalPages}`
          )} fixed />
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.TS_EXPERT_DISCLAIMER_DOTS} ${totalPages}`
          )} fixed />
        );
      }

    }
  }

  resetSummaryIndexes = () => {
    currentSummaryIndex = 0;
    duplicatedIpPageIndex = 0;
    avgPingExceededPageIndex = 0;
    dhcpConfigDetectedPageIndex = 0;
    packetLossLimitExceededPageIndex = 0;
    inactivePortPageIndex = 0;
    portNotInAutonegotiationPageIndex = 0;
    portNotInFullDuplexPageIndex = 0;
    interfaceSpeedLessThan100PageIndex = 0;
    portWithHardwareFaultPageIndex = 0;
    addressConflictDetectedPageIndex = 0;
    mediaCountersPageIndex = 0;
    interfaceCountersPageIndex = 0;
    faultPageIndex = 0;
    lostIpPageIndex = 0;
    disclaimerPageIndex = 0;
  }

  // ----------------- Duplicate IP -----------------
  createDuplicateIPPages = () => {
    if (this.props.duplicatedIp.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={duplicateIPStyles.page}>

          {this.getPageHeader()}
          <Text style={duplicateIPStyles.pageTitle} fixed>{duplicatedIpPageIndex}{Strings.DUPLICATE_IP_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DUPLICATE_IP_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />
          <Text style={reusableStyles.normalText}>{Strings.DUPLICATE_IP_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={duplicateIPStyles.table}>
            {this.createDuplicateIPTableHeader()}
            {this.createDuplicateIPTable()}
          </View>

          {this.getPageFooter("duplicatedIp")}

        </Page>
      );
    }
  }

  createDuplicateIPTableHeader = () => {
    return (
      <View style={duplicateIPStyles.tableRow} fixed>

        <View style={duplicateIPStyles.horaryTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={duplicateIPStyles.ipMacNameTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={duplicateIPStyles.ipMacNameTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.MACS}</Text>
        </View>

        <View style={duplicateIPStyles.ipMacNameTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.PRODUCT_NAMES}</Text>
        </View>

        <View style={duplicateIPStyles.checkedTableColHeader}>
          <Text style={duplicateIPStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDuplicateIPTable = () => {
    return (
      this.props.duplicatedIp.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={duplicateIPStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={duplicateIPStyles.horaryTableCol}>
              <Text style={duplicateIPStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={duplicateIPStyles.ipMacNameTableCol}>
              <Text style={duplicateIPStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={duplicateIPStyles.ipMacNameTableCol}>
              <Text style={duplicateIPStyles.tableCell}>
                {
                  problem.macs.map(mac => (
                    <Text style={duplicateIPStyles.tableCell} key={mac}>
                      {UtilsInstance.treatUppercase(mac)}{"\n"}
                    </Text>
                  ))
                }
              </Text>
            </View>

            <View style={duplicateIPStyles.ipMacNameTableCol}>
              <Text style={duplicateIPStyles.tableCell}>
                {
                  problem.names.map(name => (
                    <Text style={duplicateIPStyles.tableCell} key={name}>
                      {UtilsInstance.addWhitespaceToLongStrings(name, "")}{"\n"}
                    </Text>
                  ))
                }
              </Text>
            </View>

            <View style={duplicateIPStyles.checkedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.duplicateIpCheckBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- PING LIMIT -----------------
  createAvgPingExceededPages = () => {
    if (this.props.avgPingExceededLimit.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={avgPingExceededStyles.page}>

          {this.getPageHeader()}
          <Text style={avgPingExceededStyles.pageTitle} fixed>{avgPingExceededPageIndex}{Strings.AVG_PING_EXCEEDED_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.PING_LIMIT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.boldText}>{Strings.PING_LIMIT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.PING_LIMIT_SUGGESTION_4}</Text>

          <Text style={reusableStyles.boldText}>{Strings.PING_LIMIT_SUGGESTION_5}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.PING_LIMIT_SUGGESTION_6}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.PING_LIMIT_SUGGESTION_7}</Text>

          <Text style={reusableStyles.boldText}>{Strings.PING_LIMIT_SUGGESTION_8}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.PING_LIMIT_SUGGESTION_9}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={avgPingExceededStyles.table}>
            {this.createAvgPingExceededTableHeader()}
            {this.createAvgPingExceededTable()}
          </View>

          {this.getPageFooter("avgPingExceeded")}

        </Page>
      );
    }
  }

  createAvgPingExceededTableHeader = () => {
    return (
      <View style={avgPingExceededStyles.tableRow} fixed>

        <View style={avgPingExceededStyles.horaryTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={avgPingExceededStyles.ipTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={avgPingExceededStyles.macTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={avgPingExceededStyles.productNameTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={avgPingExceededStyles.pingTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.REGISTERED_PING}</Text>
        </View>

        <View style={avgPingExceededStyles.solvedTableColHeader}>
          <Text style={avgPingExceededStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createAvgPingExceededTable = () => {
    return (
      this.props.avgPingExceededLimit.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={avgPingExceededStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={avgPingExceededStyles.horaryTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={avgPingExceededStyles.ipTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={avgPingExceededStyles.macTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={avgPingExceededStyles.productNameTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={avgPingExceededStyles.pingNameTableCol}>
              <Text style={avgPingExceededStyles.tableCell}>{problem.ping.toFixed(2)}{Strings.MILLISECONDS_SUFFIX}</Text>
            </View>

            <View style={avgPingExceededStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- DHCP -----------------
  createDhcpConfigDetectedPages = () => {
    if (this.props.dhcpConfigDetected.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={dhcpStyles.page}>

          {this.getPageHeader()}
          <Text style={dhcpStyles.pageTitle} fixed>{dhcpConfigDetectedPageIndex}{Strings.DHCP_CONFIG_METHOD_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DHCP_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DHCP_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={dhcpStyles.table}>
            {this.createDhcpConfigDetectedTableHeader()}
            {this.createDhcpConfigDetectedTable()}
          </View>

          {this.getPageFooter("dhcpConfigDetected")}

        </Page>
      );
    }
  }

  createDhcpConfigDetectedTableHeader = () => {
    return (
      <View style={dhcpStyles.tableRow} fixed>

        <View style={dhcpStyles.horaryTableColHeader}>
          <Text style={dhcpStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={dhcpStyles.ipTableColHeader}>
          <Text style={dhcpStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={dhcpStyles.macTableColHeader}>
          <Text style={dhcpStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={dhcpStyles.productNameTableColHeader}>
          <Text style={dhcpStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={dhcpStyles.configMethodTableColHeader}>
          <Text style={dhcpStyles.tableCellHeader}>{Strings.CONFIG_METHOD}</Text>
        </View>

        <View style={dhcpStyles.solvedTableColHeader}>
          <Text style={dhcpStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createDhcpConfigDetectedTable = () => {
    return (
      this.props.dhcpConfigDetected.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={dhcpStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={dhcpStyles.horaryTableCol}>
              <Text style={dhcpStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={dhcpStyles.ipTableCol}>
              <Text style={dhcpStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={dhcpStyles.macTableCol}>
              <Text style={dhcpStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={dhcpStyles.productNameTableCol}>
              <Text style={dhcpStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={dhcpStyles.configMethodTableCol}>
              <Text style={dhcpStyles.tableCell}>{problem.config_method}</Text>
            </View>

            <View style={dhcpStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- PACKET LOSS -----------------
  createPacketLossLimitExceededPages = () => {
    if (this.props.packetLossLimitExceeded.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={packetLossStyles.page}>

          {this.getPageHeader()}
          <Text style={packetLossStyles.pageTitle} fixed>{packetLossLimitExceededPageIndex}{Strings.PACKET_LOSS_GREATER_ONE_PERCENT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.PACKET_LOSS_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>• {Strings.PACKET_LOSS_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PACKET_LOSS_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PACKET_LOSS_SUGGESTION_4}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PACKET_LOSS_SUGGESTION_5}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PACKET_LOSS_SUGGESTION_6}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.PACKET_LOSS_SUGGESTION_7}</Text>

          <Text style={reusableStyles.normalSpacedText}>
            <Text style={reusableStyles.boldText}>{Strings.OBS}</Text>
            {Strings.PACKET_LOSS_SUGGESTION_8}
          </Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={packetLossStyles.table}>
            {this.createPacketLossLimitExceededTableHeader()}
            {this.createPacketLossLimitExceededTable()}
          </View>

          {this.getPageFooter("packetLossLimitExceeded")}

        </Page>
      );
    }
  }

  createPacketLossLimitExceededTableHeader = () => {
    return (
      <View style={packetLossStyles.tableRow} fixed>

        <View style={packetLossStyles.horaryTableColHeader}>
          <Text style={packetLossStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={packetLossStyles.ipTableColHeader}>
          <Text style={packetLossStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={packetLossStyles.macTableColHeader}>
          <Text style={packetLossStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={packetLossStyles.productNameTableColHeader}>
          <Text style={packetLossStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={packetLossStyles.lostPacketsPercentageTableColHeader}>
          <Text style={packetLossStyles.tableCellHeader}>{Strings.LOST_PACKET_PERC}</Text>
        </View>

        <View style={packetLossStyles.solvedTableColHeader}>
          <Text style={packetLossStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createPacketLossLimitExceededTable = () => {
    return (
      this.props.packetLossLimitExceeded.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={packetLossStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={packetLossStyles.horaryTableCol}>
              <Text style={packetLossStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={packetLossStyles.ipTableCol}>
              <Text style={packetLossStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={packetLossStyles.macTableCol}>
              <Text style={packetLossStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={packetLossStyles.productNameTableCol}>
              <Text style={packetLossStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={packetLossStyles.lostPacketsPercentageTableCol}>
              <Text style={packetLossStyles.tableCell}>{problem.lostPacketsPercentage}%</Text>
            </View>

            <View style={packetLossStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- INACTIVE PORT -----------------
  createInactivePortPages = () => {
    if (this.props.inactivePort.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={inactivePortStyles.page}>

          {this.getPageHeader()}
          <Text style={inactivePortStyles.pageTitle} fixed>{inactivePortPageIndex}{Strings.INACTIVE_PORT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.INACTIVE_PORT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>• {Strings.INACTIVE_PORT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.INACTIVE_PORT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.INACTIVE_PORT_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={inactivePortStyles.table}>
            {this.createInactivePortTableHeader()}
            {this.createInactivePortTable()}
          </View>

          {this.getPageFooter("inactivePort")}

        </Page>
      );
    }
  }

  createInactivePortTableHeader = () => {
    return (
      <View style={inactivePortStyles.tableRow} fixed>

        <View style={inactivePortStyles.horaryTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={inactivePortStyles.ipTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={inactivePortStyles.macTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={inactivePortStyles.productNameTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={inactivePortStyles.interfaceLabelTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={inactivePortStyles.linkStatusTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.LINK_STATUS_1}{"\n"}{Strings.LINK_STATUS_2}</Text>
        </View>

        <View style={inactivePortStyles.solvedTableColHeader}>
          <Text style={inactivePortStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createInactivePortTable = () => {
    return (
      this.props.inactivePort.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={inactivePortStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={inactivePortStyles.horaryTableCol}>
              <Text style={inactivePortStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={inactivePortStyles.ipTableCol}>
              <Text style={inactivePortStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={inactivePortStyles.macTableCol}>
              <Text style={inactivePortStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={inactivePortStyles.productNameTableCol}>
              <Text style={inactivePortStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={inactivePortStyles.interfaceLabelTableCol}>
              <Text style={inactivePortStyles.tableCell}>{problem.interface_label}</Text>
            </View>

            <View style={inactivePortStyles.linkStatusTableCol}>
              <Text style={inactivePortStyles.tableCell}>{this.getLinkStatus(problem.link_status)}</Text>
            </View>

            <View style={inactivePortStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  getLinkStatus = (link_status) => {
    if (link_status === "Active") {
      return Strings.ACTIVE;
    }
    else if (link_status === "Inactive") {
      return Strings.INACTIVE;
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  // ----------------- NOT IN AUTONEGOTIATION -----------------
  createPortNotInAutonegotiationPages = () => {
    if (this.props.portNotInAutonegotiation.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={portNotInAutoNegotiationStyles.page}>

          {this.getPageHeader()}
          <Text style={portNotInAutoNegotiationStyles.pageTitle} fixed>{portNotInAutonegotiationPageIndex}{Strings.AUTONEGOTIATION_FAILED_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>• {Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_4}</Text>

          <Text style={reusableStyles.normalSpacedText}>
            <Text style={reusableStyles.boldText}>{Strings.OBS}</Text>
            {Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_5}
          </Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={portNotInAutoNegotiationStyles.table}>
            {this.createPortNotInAutonegotiationTableHeader()}
            {this.createPortNotInAutonegotiationTable()}
          </View>

          {this.getPageFooter("portNotInAutonegotiation")}

        </Page>
      );
    }
  }

  createPortNotInAutonegotiationTableHeader = () => {
    return (
      <View style={portNotInAutoNegotiationStyles.tableRow} fixed>

        <View style={portNotInAutoNegotiationStyles.horaryTableColHeader}>
          <Text style={portNotInAutoNegotiationStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={portNotInAutoNegotiationStyles.ipTableColHeader}>
          <Text style={portNotInAutoNegotiationStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={portNotInAutoNegotiationStyles.macTableColHeader}>
          <Text style={portNotInAutoNegotiationStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={portNotInAutoNegotiationStyles.productNameTableColHeader}>
          <Text style={portNotInAutoNegotiationStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={portNotInAutoNegotiationStyles.interfaceLabelTableColHeader}>
          <Text style={portNotInAutoNegotiationStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={portNotInAutoNegotiationStyles.negotiationStatusTableColHeader}>
          <Text style={portNotInAutoNegotiationStyles.tableCellHeader}>
            {Strings.NEGOTIATION_STATUS_1}{"\n"}
            {Strings.NEGOTIATION_STATUS_2}
          </Text>
        </View>

        <View style={portNotInAutoNegotiationStyles.solvedTableColHeader}>
          <Text style={portNotInAutoNegotiationStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createPortNotInAutonegotiationTable = () => {
    return (
      this.props.portNotInAutonegotiation.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={portNotInAutoNegotiationStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={portNotInAutoNegotiationStyles.horaryTableCol}>
              <Text style={portNotInAutoNegotiationStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={portNotInAutoNegotiationStyles.ipTableCol}>
              <Text style={portNotInAutoNegotiationStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={portNotInAutoNegotiationStyles.macTableCol}>
              <Text style={portNotInAutoNegotiationStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={portNotInAutoNegotiationStyles.productNameTableCol}>
              <Text style={portNotInAutoNegotiationStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={portNotInAutoNegotiationStyles.interfaceLabelTableCol}>
              <Text style={portNotInAutoNegotiationStyles.tableCell}>{problem.interface_label}</Text>
            </View>

            <View style={portNotInAutoNegotiationStyles.negotiationStatusTableCol}>
              <Text style={portNotInAutoNegotiationStyles.tableCell}>{problem.negotiation_status}</Text>
            </View>

            <View style={portNotInAutoNegotiationStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- NOT IN FULL DUPLEX -----------------
  createPortNotInFullDuplexPages = () => {
    if (this.props.portNotInFullDuplex.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={portNotInFullDuplexStyles.page}>

          {this.getPageHeader()}
          <Text style={portNotInFullDuplexStyles.pageTitle} fixed>{portNotInFullDuplexPageIndex}{Strings.PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>• {Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>• {Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalSpacedText}>
            <Text style={reusableStyles.boldText}>{Strings.OBS}</Text>
            {Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_4}
          </Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={portNotInFullDuplexStyles.table}>
            {this.createPortNotInFullDuplexTableHeader()}
            {this.createPortNotInFullDuplexTable()}
          </View>

          {this.getPageFooter("portNotInFullDuplex")}

        </Page>
      );
    }
  }

  createPortNotInFullDuplexTableHeader = () => {
    return (
      <View style={portNotInFullDuplexStyles.tableRow} fixed>

        <View style={portNotInFullDuplexStyles.horaryTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.ipTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.macTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.productNameTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.interfaceLabelTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={portNotInFullDuplexStyles.duplexModeTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>
            {Strings.DUPLEX_MODE_1}{"\n"}
            {Strings.DUPLEX_MODE_2}
          </Text>
        </View>

        <View style={portNotInFullDuplexStyles.solvedTableColHeader}>
          <Text style={portNotInFullDuplexStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createPortNotInFullDuplexTable = () => {
    return (
      this.props.portNotInFullDuplex.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={portNotInFullDuplexStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={portNotInFullDuplexStyles.horaryTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.ipTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.macTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.productNameTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.interfaceLabelTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{problem.interface_label}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.duplexModeTableCol}>
              <Text style={portNotInFullDuplexStyles.tableCell}>{problem.duplex}</Text>
            </View>

            <View style={portNotInFullDuplexStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- INTERFACE SPEED -----------------
  createInterfaceSpeedLessThan100Pages = () => {
    if (this.props.interfaceSpeedLessThan100.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={interfaceSpeedLessThan100Styles.page}>

          {this.getPageHeader()}
          <Text style={interfaceSpeedLessThan100Styles.pageTitle} fixed>{interfaceSpeedLessThan100PageIndex}{Strings.INTERFACE_SPEED_LESSER_THAN_100_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.INTERFACE_SPEED_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.INTERFACE_SPEED_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalSpacedText}>{Strings.INTERFACE_SPEED_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={interfaceSpeedLessThan100Styles.table}>
            {this.createInterfaceSpeedLessThan100TableHeader()}
            {this.createInterfaceSpeedLessThan100Table()}
          </View>

          {this.getPageFooter("interfaceSpeedLessThan100")}

        </Page>
      );
    }
  }

  createInterfaceSpeedLessThan100TableHeader = () => {
    return (
      <View style={interfaceSpeedLessThan100Styles.tableRow} fixed>

        <View style={interfaceSpeedLessThan100Styles.horaryTableColHeader}>
          <Text style={interfaceSpeedLessThan100Styles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={interfaceSpeedLessThan100Styles.ipTableColHeader}>
          <Text style={interfaceSpeedLessThan100Styles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={interfaceSpeedLessThan100Styles.macTableColHeader}>
          <Text style={interfaceSpeedLessThan100Styles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={interfaceSpeedLessThan100Styles.productNameTableColHeader}>
          <Text style={interfaceSpeedLessThan100Styles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={interfaceSpeedLessThan100Styles.interfaceLabelTableColHeader}>
          <Text style={interfaceSpeedLessThan100Styles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={interfaceSpeedLessThan100Styles.interfaceSpeedTableColHeader}>
          <Text style={interfaceSpeedLessThan100Styles.tableCellHeader}>
            {Strings.INTERFACE_SPEED_1}{"\n"}
            {Strings.INTERFACE_SPEED_2}
          </Text>
        </View>

        <View style={interfaceSpeedLessThan100Styles.solvedTableColHeader}>
          <Text style={interfaceSpeedLessThan100Styles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createInterfaceSpeedLessThan100Table = () => {
    return (
      this.props.interfaceSpeedLessThan100.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={interfaceSpeedLessThan100Styles.tableRow} key={problem.mac} wrap={false}>

            <View style={interfaceSpeedLessThan100Styles.horaryTableCol}>
              <Text style={interfaceSpeedLessThan100Styles.tableCell}>{problemDate}</Text>
            </View>

            <View style={interfaceSpeedLessThan100Styles.ipTableCol}>
              <Text style={interfaceSpeedLessThan100Styles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={interfaceSpeedLessThan100Styles.macTableCol}>
              <Text style={interfaceSpeedLessThan100Styles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={interfaceSpeedLessThan100Styles.productNameTableCol}>
              <Text style={interfaceSpeedLessThan100Styles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={interfaceSpeedLessThan100Styles.interfaceLabelTableCol}>
              <Text style={interfaceSpeedLessThan100Styles.tableCell}>{problem.interface_label}</Text>
            </View>

            <View style={interfaceSpeedLessThan100Styles.interfaceSpeedTableCol}>
              <Text style={interfaceSpeedLessThan100Styles.tableCell}>{this.getSpeed(problem.interface_speed)}</Text>
            </View>

            <View style={interfaceSpeedLessThan100Styles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  getSpeed = (interface_speed) => {
    if (interface_speed !== "") {
      return interface_speed + Strings.MEGABITS_PER_SECOND_SUFFIX;
    }
    else {
      return "";
    }
  }

  // ----------------- HARDWARE FAULT -----------------
  createPortWithHardwareFaultPages = () => {
    if (this.props.portWithHardwareFault.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={portWithHardwareFaultStyles.page}>

          {this.getPageHeader()}
          <Text style={portWithHardwareFaultStyles.pageTitle} fixed>{portWithHardwareFaultPageIndex}{Strings.PORT_WITH_LOCAL_HARDWARE_FAULT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.HARDWARE_FAULT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.HARDWARE_FAULT_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={portWithHardwareFaultStyles.table}>
            {this.createPortWithHardwareFaultTableHeader()}
            {this.createPortWithHardwareFaultTable()}
          </View>

          {this.getPageFooter("portWithHardwareFault")}

        </Page>
      );
    }
  }

  createPortWithHardwareFaultTableHeader = () => {
    return (
      <View style={portWithHardwareFaultStyles.tableRow} fixed>

        <View style={portWithHardwareFaultStyles.horaryTableColHeader}>
          <Text style={portWithHardwareFaultStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={portWithHardwareFaultStyles.ipTableColHeader}>
          <Text style={portWithHardwareFaultStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={portWithHardwareFaultStyles.macTableColHeader}>
          <Text style={portWithHardwareFaultStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={portWithHardwareFaultStyles.productNameTableColHeader}>
          <Text style={portWithHardwareFaultStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={portWithHardwareFaultStyles.interfaceLabelTableColHeader}>
          <Text style={portWithHardwareFaultStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={portWithHardwareFaultStyles.hardwareFaultTableColHeader}>
          <Text style={portWithHardwareFaultStyles.tableCellHeader}>
            {Strings.HARDWARE_FAULT_1}{"\n"}
            {Strings.HARDWARE_FAULT_2}
          </Text>
        </View>

        <View style={portWithHardwareFaultStyles.solvedTableColHeader}>
          <Text style={portWithHardwareFaultStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createPortWithHardwareFaultTable = () => {
    return (
      this.props.portWithHardwareFault.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={portWithHardwareFaultStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={portWithHardwareFaultStyles.horaryTableCol}>
              <Text style={portWithHardwareFaultStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={portWithHardwareFaultStyles.ipTableCol}>
              <Text style={portWithHardwareFaultStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={portWithHardwareFaultStyles.macTableCol}>
              <Text style={portWithHardwareFaultStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={portWithHardwareFaultStyles.productNameTableCol}>
              <Text style={portWithHardwareFaultStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={portWithHardwareFaultStyles.interfaceLabelTableCol}>
              <Text style={portWithHardwareFaultStyles.tableCell}>{problem.interface_label}</Text>
            </View>

            <View style={portWithHardwareFaultStyles.hardwareFaultTableCol}>
              <Text style={portWithHardwareFaultStyles.tableCell}>{problem.local_hardware_fault}</Text>
            </View>

            <View style={portWithHardwareFaultStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- ADDR CONFLICT -----------------
  createAddressConflictDetectedPages = () => {
    if (this.props.addressConflictDetected.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={addressConflictDetectedStyles.page}>

          {this.getPageHeader()}
          <Text style={addressConflictDetectedStyles.pageTitle} fixed>{addressConflictDetectedPageIndex}{Strings.ADDR_CONFLICT_DETECTED_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.ADDR_CONFLICT_DETECTED_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.ADDR_CONFLICT_DETECTED_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={addressConflictDetectedStyles.table}>
            {this.createAddressConflictDetectedTableHeader()}
            {this.createAddressConflictDetectedTable()}
          </View>

          {this.getPageFooter("addressConflictDetected")}

        </Page>
      );
    }
  }

  createAddressConflictDetectedTableHeader = () => {
    return (
      <View style={addressConflictDetectedStyles.tableRow} fixed>

        <View style={addressConflictDetectedStyles.horaryTableColHeader}>
          <Text style={addressConflictDetectedStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={addressConflictDetectedStyles.ipTableColHeader}>
          <Text style={addressConflictDetectedStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={addressConflictDetectedStyles.macTableColHeader}>
          <Text style={addressConflictDetectedStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={addressConflictDetectedStyles.productNameTableColHeader}>
          <Text style={addressConflictDetectedStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={addressConflictDetectedStyles.acdStatusTableColHeader}>
          <Text style={addressConflictDetectedStyles.tableCellHeader}>{Strings.ACD_STATUS}</Text>
        </View>

        <View style={addressConflictDetectedStyles.solvedTableColHeader}>
          <Text style={addressConflictDetectedStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createAddressConflictDetectedTable = () => {
    return (
      this.props.addressConflictDetected.map(problem => {
        let problemDate = this.formatTime(problem);

        return (
          <View style={addressConflictDetectedStyles.tableRow} key={problem.mac} wrap={false}>

            <View style={addressConflictDetectedStyles.horaryTableCol}>
              <Text style={addressConflictDetectedStyles.tableCell}>{problemDate}</Text>
            </View>

            <View style={addressConflictDetectedStyles.ipTableCol}>
              <Text style={addressConflictDetectedStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={addressConflictDetectedStyles.macTableCol}>
              <Text style={addressConflictDetectedStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={addressConflictDetectedStyles.productNameTableCol}>
              <Text style={addressConflictDetectedStyles.tableCell}>{problem.product_name}</Text>
            </View>

            <View style={addressConflictDetectedStyles.acdStatusTableCol}>
              <Text style={addressConflictDetectedStyles.tableCell}>{problem.acd_status}</Text>
            </View>

            <View style={addressConflictDetectedStyles.solvedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- MEDIA COUNTERS -----------------
  createMediaCountersPages = () => {
    if (this.props.mediaCounters.length > 0) {
      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={mediaCountersStyles.page}>

          {this.getPageHeader()}
          <Text style={mediaCountersStyles.pageTitle} fixed>{mediaCountersPageIndex}{Strings.TS_EXPERT_MEDIA_COUNTERS_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MEDIA_COUNTERS_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.MEDIA_COUNTERS_SUGGESTION_2}</Text>
          <Image src={process.env.PUBLIC_URL + "/images/botao-sugestoes.png"} style={interfaceCountersStyles.buttonImgStyle} />
          <Text style={reusableStyles.normalText}>{Strings.MEDIA_COUNTERS_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_1}</Text>
          <Text style={reusableStyles.lastInfoText}>{Strings.DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_2}</Text>

          <View style={mediaCountersStyles.table}>
            {this.createMediaCountersTableHeader()}
            {this.createMediaCountersTable()}
          </View>

          {this.getPageFooter("mediaCounters")}

        </Page>
      );
    }
  }

  createMediaCountersTableHeader = () => {
    return (
      <View style={mediaCountersStyles.tableRow} fixed>

        <View style={mediaCountersStyles.ipTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.ALIGNMENET_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.CARRIER_SENSE_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.FCS_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.SINGLE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.MULTIPLE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.LATE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.EXCESSIVE_COLLISIONS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.DEFERRED_TRANSMISSION}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.FRAME_TOO_LONG}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.MAC_TRANSMIT_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.restTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.MAC_RECEIVE_ERRORS}</Text>
        </View>

        <View style={mediaCountersStyles.solvedTableColHeader}>
          <Text style={mediaCountersStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>

      </View>
    );
  }

  createMediaCountersTable = () => {
    return (
      this.props.mediaCounters.map(device => {
        return (
          <View wrap={false} key={device.id}>

            <View style={mediaCountersStyles.deviceTableRow} wrap={false}>

              <View style={mediaCountersStyles.ipTableCol}>
                <Text style={mediaCountersStyles.tableCell}>{device.ip}</Text>
              </View>

              <View style={mediaCountersStyles.whitespaceTableCol}>
                <Text style={mediaCountersStyles.tableCell}></Text>
              </View>
            </View>

            {
              device.instances.map(instance => {
                if (instance.has_media_counters_increment) {
                  return (
                    <View style={mediaCountersStyles.tableRow} key={instance.interface_label} wrap={false}>

                      <View style={mediaCountersStyles.ipTableCol}>
                        <Text style={mediaCountersStyles.tableCell}>{instance.interface_label}</Text>
                      </View>

                      {this.getCounterCell(instance.alignment_errors, instance.alignment_errors_delta)}
                      {this.getCounterCell(instance.carrier_sense_errors, instance.carrier_sense_errors_delta)}
                      {this.getCounterCell(instance.fcs_errors, instance.fcs_errors_delta)}
                      {this.getCounterCell(instance.single_collisions, instance.single_collisions_delta)}
                      {this.getCounterCell(instance.multiple_collisions, instance.multiple_collisions_delta)}
                      {this.getCounterCell(instance.late_collisions, instance.late_collisions_delta)}
                      {this.getCounterCell(instance.excessive_collisions, instance.excessive_collisions_delta)}
                      {this.getCounterCell(instance.deferred_transmission, instance.deferred_transmission_delta)}
                      {this.getCounterCell(instance.frame_too_long, instance.frame_too_long_delta)}
                      {this.getCounterCell(instance.mac_transmit_errors, instance.mac_transmit_errors_delta)}
                      {this.getCounterCell(instance.mac_receive_errors, instance.mac_receive_errors_delta)}

                      <View style={mediaCountersStyles.solvedTableCol}>
                        <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox2} />
                      </View>

                    </View>
                  );
                }
              })
            }
          </View>
        );
      })
    );
  }

  getCounterCell = (counter, delta) => {
    if (delta > 0) {
      return (
        <View style={mediaCountersStyles.errorRestTableCol}>
          <Text style={mediaCountersStyles.tableCell}>{counter}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={mediaCountersStyles.restTableCol}>
          <Text style={mediaCountersStyles.tableCell}>{counter}</Text>
        </View>
      );
    }
  }

  // ----------------- INTERFACE COUNTERS -----------------
  createInterfaceCountersPages = () => {
    if (this.props.interfaceCounters.length > 0) {

      return (
        <Page
          size="A4"
          orientation="landscape"
          wrap={true}
          style={interfaceCountersStyles.page}>

          {this.getPageHeader()}
          <Text style={interfaceCountersStyles.pageTitle} fixed>{interfaceCountersPageIndex}{Strings.TS_EXPERT_INTERFACE_COUNTERS_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.INTERFACE_COUNTERS_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.INTERFACE_COUNTERS_SUGGESTION_2}</Text>
          <Image src={process.env.PUBLIC_URL + "/images/botao-sugestoes.png"} style={interfaceCountersStyles.buttonImgStyle} />
          <Text style={reusableStyles.normalText}>{Strings.INTERFACE_COUNTERS_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_1}</Text>
          <Text style={reusableStyles.lastInfoText}>{Strings.DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_2}</Text>

          <View style={interfaceCountersStyles.table}>
            {this.createInterfaceCountersTableHeader()}
            {this.createInterfaceCountersTable()}
          </View>

          {this.getPageFooter("interfaceCounters")}

        </Page>
      );
    }
  }

  createInterfaceCountersTableHeader = () => {
    return (
      <View style={interfaceCountersStyles.tableRow} fixed>

        <View style={interfaceCountersStyles.ipTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.TRAFFIC_KBPS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IN_DISCARDS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IN_ERRORS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.IN_UNKNOWN_PROTOS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.TRAFFIC_KBPS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.OUT_DISCARDS}</Text>
        </View>

        <View style={interfaceCountersStyles.restTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.OUT_ERRORS}</Text>
        </View>

        <View style={interfaceCountersStyles.solvedTableColHeader}>
          <Text style={interfaceCountersStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>

      </View>
    );
  }

  createInterfaceCountersTable = () => {
    return (
      this.props.interfaceCounters.map(device => {
        return (
          <View wrap={false} key={device.id}>

            <View style={interfaceCountersStyles.deviceTableRow} wrap={false}>

              <View style={interfaceCountersStyles.ipTableCol}>
                <Text style={interfaceCountersStyles.tableCell}>{device.ip}</Text>
              </View>

              <View style={interfaceCountersStyles.whitespaceTableCol}>
                <Text style={interfaceCountersStyles.tableCell}></Text>
              </View>
            </View>

            {
              device.instances.map(instance => {
                if (instance.has_interface_counters_increment) {
                  return (
                    <View style={interfaceCountersStyles.tableRow} key={instance.interface_label} wrap={false}>

                      <View style={interfaceCountersStyles.ipTableCol}>
                        <Text style={interfaceCountersStyles.tableCell}>{instance.interface_label}</Text>
                      </View>

                      {this.getTrafficCell(instance.input_kbps)}
                      {this.getErrorDiscardCell(instance.in_discards, instance.in_discards_delta)}
                      {this.getErrorDiscardCell(instance.in_errors, instance.in_errors_delta)}
                      {this.getErrorDiscardCell(instance.in_unknown_protos, instance.in_unknown_protos_delta)}
                      {this.getTrafficCell(instance.exit_kbps)}
                      {this.getErrorDiscardCell(instance.out_discards, instance.out_discards_delta)}
                      {this.getErrorDiscardCell(instance.out_errors, instance.out_errors_delta)}

                      <View style={interfaceCountersStyles.solvedTableCol}>
                        <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.checkBox3} />
                      </View>

                    </View>
                  );
                }
              })
            }
          </View>
        );
      })
    );
  }

  getTrafficCell = (kbps) => {
    if (kbps == "") {
      return (
        <View style={interfaceCountersStyles.restTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{Strings.ZERO_TRAFFIC}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={interfaceCountersStyles.restTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{kbps.toFixed(2)} Kbps</Text>
        </View>
      );
    }
  }

  getErrorDiscardCell = (counter, delta) => {
    if (delta > 0) {
      return (
        <View style={interfaceCountersStyles.errorTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{counter}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={interfaceCountersStyles.restTableCol}>
          <Text style={interfaceCountersStyles.tableCell}>{counter}</Text>
        </View>
      );
    }
  }

  // ----------------- FAULTS -----------------
  createFaultsPages = () => {
    if (this.props.faults.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={alarmStyles.page}>

          {this.getPageHeader()}

          <Text style={alarmStyles.pageTitle} fixed>{faultPageIndex}{Strings.FAULT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.FAULT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_4}</Text>
          <Text style={reusableStyles.normalText}>• {Strings.FAULT_SUGGESTION_5}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={alarmStyles.table}>
            {this.createFaultsTableHeader()}
            {this.createFaultsTable()}
          </View>

          {this.getPageFooter("fault")}

        </Page>
      );
    }
  }

  createFaultsTableHeader = () => {
    return (
      <View style={alarmStyles.tableRow} fixed>

        <View style={alarmStyles.horaryTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={alarmStyles.ipTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={alarmStyles.macTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={alarmStyles.productNameTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.PRODUCT_NAME}</Text>
        </View>

        <View style={alarmStyles.solvedTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createFaultsTable = () => {
    return (
      this.props.faults.map(problem => {
        return (
          <View style={alarmStyles.tableRow} key={problem._id} wrap={false}>

            <View style={alarmStyles.horaryTableCol}>
              <Text style={alarmStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={alarmStyles.ipTableCol}>
              <Text style={alarmStyles.tableCell}>{problem.ip}</Text>
            </View>

            <View style={alarmStyles.macTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={alarmStyles.productNameTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.product_name, false)}</Text>
            </View>

            <View style={alarmStyles.checkedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.duplicateIpCheckBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- LOST IP -----------------
  createLostIpPages = () => {
    if (this.props.lostIp.length > 0) {

      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={alarmStyles.page}>

          {this.getPageHeader()}

          <Text style={alarmStyles.pageTitle} fixed>{lostIpPageIndex}{Strings.LOST_IP_PAGE_TITLE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.LOST_IP_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>• {Strings.LOST_IP_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={alarmStyles.table}>
            {this.createLostIpTableHeader()}
            {this.createLostIpTable()}
          </View>

          {this.getPageFooter("lostIp")}

        </Page>
      );
    }
  }

  createLostIpTableHeader = () => {
    return (
      <View style={alarmStyles.tableRow} fixed>

        <View style={alarmStyles.horaryTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={alarmStyles.ipTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={alarmStyles.macTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={alarmStyles.productNameTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.MODEL}</Text>
        </View>

        <View style={alarmStyles.solvedTableColHeader}>
          <Text style={alarmStyles.tableCellHeader}>{Strings.CHECKED}</Text>
        </View>
      </View>
    );
  }

  createLostIpTable = () => {
    return (
      this.props.lostIp.map(problem => {
        return (
          <View style={alarmStyles.tableRow} key={problem._id} wrap={false}>

            <View style={alarmStyles.horaryTableCol}>
              <Text style={alarmStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={alarmStyles.ipTableCol}>
              <Text style={alarmStyles.tableCell}>0.0.0.0</Text>
            </View>

            <View style={alarmStyles.macTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.treatUppercase(problem.mac)}</Text>
            </View>

            <View style={alarmStyles.productNameTableCol}>
              <Text style={alarmStyles.tableCell}>{UtilsInstance.addWhitespaceToLongStrings(problem.model, false)}</Text>
            </View>

            <View style={alarmStyles.checkedTableCol}>
              <Image src={process.env.PUBLIC_URL + "/images/empty-rect.png"} style={reusableStyles.duplicateIpCheckBox} />
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    this.resetSummaryIndexes();
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  centeredSubHeaderText: {
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center",
  },

  centeredSecondSubHeaderText: {
    marginTop: "3vh",
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginTop: "1vh",
    marginBottom: 4,
    fontFamily: "RobotoMedium"
  },

  normalSpacedText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  checkBox: {
    width: 12,
    height: 12,
    marginTop: "1vh",
    marginLeft: "20"
  },

  checkBox2: {
    width: 12,
    height: 12,
    marginTop: "3",
    marginLeft: "36"
  },

  checkBox3: {
    width: 12,
    height: 12,
    marginTop: "3",
    marginLeft: "33"
  },

  duplicateIpCheckBox: {
    width: 12,
    height: 12,
  },

  mainTitleUpperLine: {
    marginTop: "2vh",
    marginBottom: "2vh",
    marginLeft: "180px",
    height: "1px",
    width: "156px",
    backgroundColor: "black",
  },

  mainTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle2: {
    marginTop: "1vh",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitleBottomLine: {
    marginTop: "2vh",
    marginLeft: "206px",
    height: "1px",
    width: "100px",
    backgroundColor: "black",
  },

  noErrors: {
    //marginTop: "28vh",
    textAlign: "center",
    fontSize: 12,
    //marginBottom: "4vh",
    //fontWeight: "bold",
    fontFamily: "RobotoRegular"
  },

});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const duplicateIPStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipMacNameTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  checkedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipMacNameTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  checkedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const avgPingExceededStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  pingTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  pingNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const dhcpStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  configMethodTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  configMethodTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const packetLossStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  lostPacketsPercentageTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  lostPacketsPercentageTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const inactivePortStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  linkStatusTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  linkStatusTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const portNotInAutoNegotiationStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  negotiationStatusTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  negotiationStatusTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const portNotInFullDuplexStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  duplexModeTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  duplexModeTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const interfaceSpeedLessThan100Styles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceSpeedTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceSpeedTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const portWithHardwareFaultStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  hardwareFaultTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  hardwareFaultTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const addressConflictDetectedStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  acdStatusTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  acdStatusTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const mediaCountersStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 110
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  restTableColHeader: {
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  deviceTableRow: {
    margin: "auto",
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  ipTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "88%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  restTableCol: {
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  errorRestTableCol: {
    backgroundColor: "#ff6600",
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  },

  buttonImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "1vh",
    marginBottom: "1vh",
    height: "32px",
    width: "180px"
  }
});

const interfaceCountersStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 110
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  ipTableColHeader: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  restTableColHeader: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  deviceTableRow: {
    margin: "auto",
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  ipTableCol: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "87%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  restTableCol: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  errorTableCol: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ff6600"
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  },

  buttonImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "1vh",
    marginBottom: "1vh",
    height: "32px",
    width: "180px"
  }
});

const alarmStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  productNameTableColHeader: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  productNameTableCol: {
    width: "30%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  checkedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

export default TsExpertReport;
